import React, { useMemo } from "react";
import moment from "moment-timezone"; // Ensure moment-timezone is imported

import HeaderSection from "../components/fourth_screen/Header";
import DateSection from "../components/fourth_screen/DateTimes";
import PrayerTimes from "../components/fourth_screen/PrayerTimes";
import BottomSection from "../components/fourth_screen/OtherTimes";

// ✅ Import the utility
import { getNextPrayerOrJummah } from "../utils/prayerUtils";

export default function FourthScreen({
  colorSettings = {},
  prayerData,
  currentTime,
  timezone, // ✅ Ensure timezone is passed from ScreenResolver
  moduleData
}) {
  const {
    headerBackgroundColor = "#000000",
    headerTextColor = "#ffffff",
    
    bodyBackgroundColor = "#000000",
    bodyTextColor = "#ffffff",
    bodyTimingColor = "#a3e635", 
    
    highlightColor = "#facc15", 
    
    footerBackgroundColor = "#000000",
    footerTextColor = "#ffffff",
    footerTimingColor = "#a3e635",
  } = colorSettings;

  // -----------------------------------------------------------
  // ✅ LOGIC: Calculate Next Event & Jummah Mode (Same as Third Screen)
  // -----------------------------------------------------------
  
  const nextEvent = useMemo(() => {
    if (!prayerData || !timezone || !currentTime) return null;
    return getNextPrayerOrJummah(
        currentTime, 
        prayerData.iqamatimes, 
        prayerData.jummahTimes, 
        prayerData.startTimes?.timings, // Fallback start times
        0
    );
  }, [currentTime, prayerData, timezone]);

  const isJummahMode = useMemo(() => {
    if (!prayerData?.iqamatimes || !currentTime) return false;
    if (nextEvent?.type === 'jummah') return true;

    const isFriday = currentTime.day() === 5;
    if (isFriday) {
       const dateStr = currentTime.format("YYYY-MM-DD");
       const dhuhrStr = prayerData.iqamatimes.dhuhr || prayerData.iqamatimes.zuhr;
       const asrStr = prayerData.iqamatimes.asr;

       if (dhuhrStr && asrStr) {
          const dhuhrTime = moment.tz(`${dateStr} ${dhuhrStr}`, "YYYY-MM-DD h:mm A", timezone);
          const asrTime = moment.tz(`${dateStr} ${asrStr}`, "YYYY-MM-DD h:mm A", timezone);
          if (currentTime.isSameOrAfter(dhuhrTime) && currentTime.isBefore(asrTime)) return true;
       }
    }
    return false;
  }, [currentTime, prayerData, timezone, nextEvent]);

  if (!prayerData || !currentTime) return <div className="text-white text-center mt-20">Loading...</div>;

  return (
    <div 
      className="w-screen h-[100svh] overflow-hidden flex flex-col"
      style={{ backgroundColor: bodyBackgroundColor }}
    >
        {/* Header */}
        <div style={{ backgroundColor: headerBackgroundColor }}>
           <HeaderSection textColor={headerTextColor} />
        </div>

        {/* Date & Time Section */}
        <DateSection 
            currentTime={currentTime} 
            prayerData={prayerData}
            textColor={bodyTextColor}
            timingColor={bodyTimingColor}
        />

        {/* Prayer Grid */}
        <div className="flex-1 flex flex-col justify-center">
            <PrayerTimes 
                prayerData={prayerData} 
                // ✅ Pass the calculated logic props
                nextEvent={nextEvent}
                isJummahMode={isJummahMode}
                
                textColor={bodyTextColor}
                timingColor={bodyTimingColor}
                highlightColor={highlightColor}
            />
        </div>

        {/* Bottom Section */}
        <div className="mt-auto pb-4" style={{ backgroundColor: footerBackgroundColor }}>
          <BottomSection 
            prayerData={prayerData} 
            textColor={footerTextColor}
            timingColor={footerTimingColor}
            moreInfoUrl="https://connectummah.com" 
          />
        </div>
    </div>
  );
}